class Config {
  constructor() {
    this.version = ''
    this.basepath = '/'
    this.api_base_url = 'https://no_global_config_init'
    this.activeLogLevel = 'OFF'
    this.app_hash = ''
    this.featureFlags = []
    this.csrfToken = null
    this.navigate = () => null
    this.init = this.init.bind(this)
    this.setNavigate = this.setNavigate.bind(this)
    this.local_storage_compression = false
    this.client_id = null
    this.auth_providers = ['summit']
    this.systemCheckFrequency = 4.5
    this.publicKey = ''
    this.heap_id = null
    this.coverage_enabled = false
  }
  init(version) {
    this.version = version
    this.config =
      JSON.parse(document.getElementById('app-config').innerHTML) || {}
    const DEBUG = this.config.DEBUG || 'OFF'
    let BASEPATH = this.config.BASE_PATH || '/'
    if (BASEPATH !== '/') {
      // ensure there is a leading slash
      BASEPATH = BASEPATH.substring(0, 1) !== '/' ? '/' + BASEPATH : BASEPATH
      // ensure there is a trailing slash
      BASEPATH =
        BASEPATH.substring(BASEPATH.length - 1) !== '/'
          ? BASEPATH + '/'
          : BASEPATH
    }

    this.basepath = BASEPATH
    this.api_base_url =
      this.config.API_BASE_URL || 'https://unable_to_parse_config'
    this.activeLogLevel = DEBUG.toUpperCase()
    this.app_hash = this.config.APP_HASH || ''
    this.client_id = this.config.CLIENT_ID
    this.heap_id = this.config.HEAP_ID
    this.auth_providers = this.config.AUTH_PROVIDERS.split(',')
    this.local_storage_compression = this.config.LOCAL_STORAGE_COMPRESSION
    this.systemCheckFrequency = this.config.SYSTEM_CHECKS
      ? Math.max(2, this.config.SYSTEM_CHECKS - 0.5)
      : 4.5
    this.publicKey = this.config.PUBLIC_KEY || ''
    this.featureFlags = this.config.FEATURE_FLAGS || {}
    this.coverage_enabled = ['TRUE', 'true', '1'].includes(this.config.COVERAGE_ENABLED)

    this.getCsrfToken()
  }
  // Mirror the backend App\Helper\Feature::active(): a flag is active unless a row
  // explicitly disables it (enabled === false). An absent flag is active.
  //
  // featureFlags has two possible shapes: the name-keyed object embedded in
  // #app-config at page load (json_encode of the DB feature_flags), and the array
  // the Feature Flags admin screen overwrites it with after an edit. Handle both so
  // the answer is correct without an API call regardless of how the user got here.
  isFeatureActive(name) {
    const flags = this.featureFlags
    const flag = Array.isArray(flags)
      ? flags.find(f => f && f.name === name)
      : flags && flags[name]
    return flag?.enabled !== false
  }
  getCsrfToken() {
    const csrfToken = document
      .getElementsByName('csrf-token')[0]
      .getAttribute('content')
    this.csrfToken = csrfToken === '' ? null : csrfToken
    return this.csrfToken
  }
  clearCsrfToken() {
    this.csrfToken = null
    document.getElementsByName('csrf-token')[0].setAttribute('content', '')
  }
  setCsrfToken(token) {
    this.csrfToken = token
    document.getElementsByName('csrf-token')[0].setAttribute('content', token)
  }
  setNavigate(navigate) {
    this.navigate = navigate
  }
}

const globalConfig = new Config()

export default globalConfig
